import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemText,
  Table, TableBody, TableCell, TableRow, TableContainer, TableHead, Switch, FormControlLabel, Checkbox, Paper, Tooltip, IconButton, InputLabel, Select
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import LockIcon from '@material-ui/icons/Lock';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import {
  getKoordinat,
  GetLocation,
  getUser,
  moneyFormat
} from 'src/utils/Common';
import { uploadFotograf } from 'src/utils/storage/StrPhoto';
import { setTask } from '../../store/actions/taskActions';
import { getTasksRequest } from '../../store/actions';
import ForPartner from '../MaterialOrder2/Create/ForPartner';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SaveIcon from '@material-ui/icons/Save';
import axiosHeadOffice from 'src/utils/axiosHeadOffice';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DeleteIcon from '@material-ui/icons/Delete';
import TriageMaterialOrder from 'src/views/MaterialOrder2/Create/TriageMaterialOrder'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CloseIcon from '@material-ui/icons/Close';
import Hizmet from 'src/views/DefectsAndMaterials';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { paymentActions, paymentThunks } from 'src/store/slices/paymentSlice';
import {
  applyManualDiscount as applyManualDiscountRequest
} from 'src/store/slices/manualDiscountSlice';
import ManualDiscountDialog from './ManualDiscountDialog';
import PaymentDetailsDialog from './PaymentDetailsDialog';

const useStyles = makeStyles(theme => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  cardsMax: {
    maxHeight: 750,
    minHeight: 750,
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'none',
      minHeight: 0,
      overflow: 'visible'
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
function Sonlandir({
  className,
  ReceiptNo,
  readonly,
  setReadonly,
  tasks,
  materialReducer,
  setTask,
  getTasksRequest
}) {
  const [open, setOpen] = React.useState(false);
  const [Uyari1, setUyari1] = React.useState('');
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [isButtonDisabled, setisButtonDisabled] = React.useState(false);
  const [isButtonDisabled2, setisButtonDisabled2] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState('success');
  const [islemYeri, setIslemYeri] = useState('0');
  const [sourceOfDefect, setSourceOfDefect] = useState(0);
  const [sourceOfDefectData, setSourceOfDefectData] = useState([]);
  const [selectedMobileStatus, setSelectedMobileStatus] = useState('')
  const [tahsilatTipi, setTahsilatTipi] = useState(0);
  const [tahsilatGoster, setTahsilatGoster] = useState(false);
  const [sonDurum, setSonDurum] = useState('0');
  const [reworkDurum, setReworkDurum] = useState('0');
  const [TotalTransportPrice, setTotalTransportPrice] = useState(0);
  const [sonDurumAciklama, setSonDurumAciklama] = useState(t('Son_Durum'));
  const [tutar, setTutar] = useState(0);
  const [openLegal, setOpenLegal] = useState(false);
  const [error, setError] = useState(false);
  const [StatusData, setStatusData] = useState([]);
  const [ReworkData, setReworkData] = useState([]);
  const [activePaymentTypeData, setActivePaymentTypeData] = useState([]);
  const [OpenResponse, setOpenResponse] = useState(false);
  const [ResponseData, setResponseData] = useState([]);
  const [ClosePopupControl, setClosePopupControl] = useState(false);
  const [ClosePopupHeader, setClosePopupHeader] = useState('');
  const [CloseBtn1, setCloseBtn1] = useState('');
  const [CloseBtn2, setCloseBtn2] = useState('');
  const [CloseTypePopupControl1, setCloseTypePopupControl1] = useState(0);
  const [CloseTypePopupControl2, setCloseTypePopupControl2] = useState(0);
  const [PlaceData, setPlaceData] = useState([]);
  const history = useHistory();
  const SessionUser = getUser();
  const [Required, setRequired] = useState(false);
  const [IsStatusNoteRequired, setIsStatusNoteRequired] = useState(false);
  const [Compensation, setCompensation] = useState([]);
  const [ManufacturingFault, setManufacturingFault] = useState('');
  const [defectsAndMaterials, setDefectsAndMaterials] = useState([]);
  const [defectAndMaterialList, setDefectAndMaterialList] = useState([]);
  const [OpenAIDialog, setOpenAIDialog] = useState(false);
  const [selectedDefect, setSelectedDefect] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [matchedPairs, setMatchedPairs] = useState([]);
  const [predictions, setPredictions] = useState([]);
  const [OpenTriageMaterialOrder, setOpenTriageMaterialOrder] = useState(false);
  const [IsAI, setIsAI] = useState(false)
  const [OrderNr, setOrderNr] = useState('');

  const [MaterialOrderId, setMaterialOrderId] = useState(0);
  const [OpenMaterialOrder, setOpenMaterialOrder] = useState(false);
  const isCancelledRef = useRef(false);
  const [OpenUsedNotUsedDialog, setOpenUsedNotUsedDialog] = useState(false);
  const [usedNotusedValue, setusedNotusedValue] = React.useState('used');
  const [WarrantyData, setWarrantyData] = useState([]);
  const [RefurbishmentId, SetRefurbishmentId] = useState('0');
  const [RefurbishmentData, SetRefurbishmentData] = useState([]);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false)
  const [UsedNotUsedData, SetUsedNotUsedData] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [checked, setChecked] = useState([])
  const [openCancellationPopup, setOpenCancellationPopup] = useState(false);
  const [CancellationReasonId, setCancellationReasonId] = useState({
    Id: 0,
    MainLanguageDescription: ''
  });
  const [CancellationNote, setCancellationNote] = useState('');
  const [cancellationReasonsData, setCancellationReasonsData] = useState([]);

  const [discountParams, setDiscountParams] = useState([]);
  const [PayButtonActive, setPayButtonActive] = useState(false);
  const [paymentLocalError, setPaymentLocalError] = useState('');
  const [showPaymentIframe, setShowPaymentIframe] = useState(false);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [selectedPos, setSelectedPos] = useState('');
  const [showManualDiscountDialog, setShowManualDiscountDialog] = useState(false);
  const [showPaymentDetailsDialog, setShowPaymentDetailsDialog] = useState(false);
  const [paymentDetailsData, setPaymentDetailsData] = useState([]);
  const [paymentDetailsLoading, setPaymentDetailsLoading] = useState(false);
  const [manualDiscountTotals, setManualDiscountTotals] = useState(null);
  const [discountLabourTotal, setDiscountLabourTotal] = useState('');
  const [discountMaterialTotal, setDiscountMaterialTotal] = useState('');
  const [discountTransportTotal, setDiscountTransportTotal] = useState('');
  const [discountExtraTotal, setDiscountExtraTotal] = useState('');
  const [discountSuccessMessage, setDiscountSuccessMessage] = useState('');
  const [discountErrorMessage, setDiscountErrorMessage] = useState('');
  const [discountDetails, setDiscountDetails] = useState([]);
  const [dawlanceShares, setDawlanceShares] = useState([]);

  // Payment Redux state
  const repairData = useSelector(s => s.payment?.repairPreSaleData) || null;
  const repairLoading = useSelector(s => s.payment?.repairPreSaleLoading) === 'Loading';
  const repairError = useSelector(s => s.payment?.repairPreSaleError) || null;
  const posMatchingList = useSelector(s => s.payment?.employeePosMatchingList) || [];
  const posMatchingLoading = useSelector(s => s.payment?.employeePosMatchingLoading) === 'Loading';
  const repairOrderConditions = useSelector(s => s.payment?.repairOrderConditions) || [];
  const posTenantVatRate = useSelector(s => s.payment?.posTenantVatRate);
  const manualDiscountLoading = useSelector(s => s.manualDiscount?.applyingDiscount) || false;
  const isPosTenant = posTenantVatRate?.IsSuccess === true;
  const posVatRate = isPosTenant ? (posTenantVatRate.ResponseObject?.VatRate ?? 0.21) : 0.21;

  const dispatch = useDispatch();

  const SaveCancellation = CloseType => {
    const Data = {
      CancellationNote: CancellationNote,
      CancellationReasonId: CancellationReasonId?.Id,
    }
    handleMerkezeGonderEvet(Data, CloseType);
  }
  // const [selectedDiscount, setSelectedDiscount] = useState(null);

  // const handleSelectChange = (event) => {
  //   const selectedValue = event.target.value;
  //   setSelectedDiscount(selectedValue);
  // };

  const handleCloseopenLegal = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenLegal(false);
  };
  const handleSubmit = event => {
    event.preventDefault();
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const GetActivePaymentTypes = () => {
    axios
      .get(`/GetActivePaymentTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setActivePaymentTypeData(response.data);
        }
      })
      .catch(error => { });
  };

  const GetRefurbishmentGrade = () => {
    axios
      .get(`/GetRefurbishmentGrade`)
      .then(response => {
        if (response.data.length > 0) {
          SetRefurbishmentData(response.data);
        }
      })
      .catch(error => { });
  };

  const GetActiveReworkStatus = () => {
    axios
      .get(`/GetActiveReworkStatus`)
      .then(response => {
        if (response.data.length > 0) {
          setReworkData(response.data);
        }
      })
      .catch(error => { });
  };
  const CancellationReasons = () => {
    axios
      .get(`/GetCancellationReasons`)
      .then(response => {
        if (response.data.length > 0) {
          setCancellationReasonsData(response.data);

        }
      })
      .catch(error => { });
  };
  const GetSourceOfDefectTypes = () => {
    axios
      .get(`/GetSourceOfDefectTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setSourceOfDefectData(response.data);
          if (SessionUser.TenantId == 64 && !(SonlandirData[0]?.SourceOfDefect)) {
            let job = { ...SonlandirData[0], SourceOfDefect: 2 };
            setTask(job);
            setSourceOfDefect(2);
          }
        }
      })
      .catch(error => { });
  };
  const GetPlace = () => {
    axios
      .get(`/GetPlace`)
      .then(response => {
        if (response.data.length > 0) {
          setPlaceData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetWarranty = () => {
    axios
      .get(`/GetSiriusWarrantyType`)
      .then(response => {
        if (response.data.length > 0) {
          setWarrantyData(response.data);
        }
      })
      .catch(error => { });
  };

  const GetTenantDiscountCondition = () => {
    axios
      .get(`/GetTenantDiscountCondition`)
      .then(response => {
        if (response.data.length > 0) {
          setDiscountParams(response.data);
        }
      })
      .catch(error => {
        setDiscountParams([]);
      });
  };

  var WarrantyTypeId = 0
  var SonlandirData = tasks.tasks.filter(d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
  const manualDiscountItems = useMemo(() => {
    const job = SonlandirData[0];
    if (!job) return [];
    const getPrice = item => Number(item.Price ?? item.MaterialPrice ?? item.LabourPrice) || 0;
    const getVatPrice = item => Number(item.PriceWithWat ?? item.MaterialPriceWithWat ?? item.LabourPriceWithWat) || getPrice(item);
    const getId = item => item.Id || item.WorkOrderDetailId || item.WorkOrderDetailID
      || item.WorkOrderMaterialId || item.WorkOrderLabourId;
    const rows = [];
    (job.WorkOrderLabours || []).forEach((item, index) => rows.push({
      workOrderDetailId: getId(item), typeId: 1, itemLabel: `L-${index + 1}`,
      materialId: item.MaterialId || item.LabourId,
      itemCode: item.LabourCode || item.MaterialCode || '',
      description: item.LabourDesc || item.MaterialDesc || item.Description || item.Dsc || '-',
      basePrice: getPrice(item), vatIncludedPrice: getVatPrice(item), quantity: 1
    }));
    (job.WorkOrderMaterials || []).forEach((item, index) => rows.push({
      workOrderDetailId: getId(item), typeId: 2, itemLabel: `M-${index + 1}`,
      materialId: item.MaterialId,
      itemCode: item.MaterialCode || '',
      description: item.MaterialDesc || item.Description || item.Dsc || '-',
      basePrice: getPrice(item), vatIncludedPrice: getVatPrice(item), quantity: item.Count || item.Quantity || 1
    }));
    (job.WorkOrderTransport || []).forEach((item, index) => rows.push({
      workOrderDetailId: getId(item), typeId: 3, itemLabel: `T-${index + 1}`,
      materialId: item.MaterialId,
      itemCode: item.MaterialCode || '',
      description: item.MaterialDesc || item.Description || item.Dsc || '-',
      basePrice: getPrice(item), vatIncludedPrice: getVatPrice(item), quantity: 1
    }));
    (job.WorkOrderExtra || []).forEach((item, index) => rows.push({
      workOrderDetailId: getId(item), typeId: 4, itemLabel: `E-${index + 1}`,
      materialId: item.MaterialId,
      itemCode: item.MaterialCode || '',
      description: item.MaterialDesc || item.Description || item.Dsc || '-',
      basePrice: getPrice(item), vatIncludedPrice: getVatPrice(item), quantity: 1
    }));
    return rows;
  }, [SonlandirData[0]]);
  const currentWarrantyGroupId = SonlandirData[0]?.WarrantyGroupId
    ?? WarrantyData?.find(w => Number(w.WarrantyId) === Number(SonlandirData[0]?.WarrantyTypeId))?.WarrantyGroupId;
  const currentServiceShopTypeId = SonlandirData[0]?.ServiceShopTypeId
    ?? SonlandirData[0]?.ServiceShopType;
  const canShowDiscount = Boolean(
    (SonlandirData[0]?.WorkOrderMaterials?.length > 0
      || SonlandirData[0]?.WorkOrderLabours?.length > 0)
    && discountParams.some(d => Number(d.WarrantyGroupId) === Number(currentWarrantyGroupId)
      && Number(d.ServiceShopTypeId) === Number(currentServiceShopTypeId))
  );
  if (WarrantyData?.length > 0 && SonlandirData.length > 0) {
    WarrantyTypeId = WarrantyData?.filter(x => x.WarrantyId === SonlandirData[0].WarrantyTypeId);
  }


  let SonucNotuDeger = '';
  let ProjeKoduDeger = '';
  let DiscountTypeData = [];
  let DiscountRateData = [];
  let dscType = 0;
  if (SonlandirData === undefined || SonlandirData[0] === undefined) {
    SonucNotuDeger = '';
    ProjeKoduDeger = '';
  } else {
    SonucNotuDeger = SonlandirData[0]?.Notes || '';
    ProjeKoduDeger = SonlandirData[0]?.ProjectCode || '';
    DiscountTypeData = SonlandirData[0]?.DiscountTypes || [];
    DiscountRateData = SonlandirData[0]?.DiscountRates || [];
    dscType = SonlandirData[0]?.DiscountTypeId || 0;
  }
  const [SonucNotu, setSonucNotu] = useState('');
  const [ProjeKodu, setProjeKodu] = useState(ProjeKoduDeger);
  const [DiscountTypeId, SetDiscountTypeId] = useState(dscType);

  const handleChangeDiscountType = event => {
    const job = {
      ...SonlandirData[0],
      DiscountTypeId: event.target.value
    };
    setTask(job);
    SetDiscountTypeId(event.target.value);
  };

  const handleChangeDiscountRate = event => {
    const job = {
      ...SonlandirData[0],
      DiscountRateId: event.target.value
    };
    setTask(job);
  };

  let currMaterialSum = 0;
  let currLabourSum = 0;
  let currMaterialVatSum = 0;
  let currLabourVatSum = 0;
  let transportTotal = 0;
  let transportTotalWithWat = 0;
  let extraTotal = 0;
  let extraTotalWithWat = 0;

  if (SonlandirData !== undefined && SonlandirData[0] !== undefined) {

    if (SonlandirData[0]?.WorkOrderMaterials !== undefined) {
      SonlandirData[0].WorkOrderMaterials.forEach((item) => {
        if (WarrantyTypeId && WarrantyTypeId.length > 0 && WarrantyTypeId[0]?.WarrantyId === 471) {
          currMaterialVatSum = 0;
          currMaterialSum = 0;
        }
        else {
          if (isPosTenant) {
            if (item.Price !== undefined && item.Price !== null && !isNaN(item.Price)) {
              currMaterialSum += Math.round(item.Price * 100) / 100 * item.Count;
              currMaterialVatSum += Math.round(item.PriceWithWat * 100) / 100 * item.Count;
            } else if (item.MaterialPriceWithWat !== undefined && item.MaterialPriceWithWat !== null && !isNaN(item.MaterialPriceWithWat)) {
              currMaterialSum += Math.round(item.MaterialPrice * 100) / 100 * item.Count;
              currMaterialVatSum += Math.round(item.MaterialPriceWithWat * 100) / 100 * item.Count;
            }
          }
          else {
            if (item.Price !== undefined && item.Price !== null && !isNaN(item.Price)) {
              currMaterialSum += item.Price * item.Count;
              currMaterialVatSum += item.PriceWithWat * item.Count;
            } else if (item.MaterialPriceWithWat !== undefined && item.MaterialPriceWithWat !== null && !isNaN(item.MaterialPriceWithWat)) {
              currMaterialSum += item.MaterialPrice * item.Count;
              currMaterialVatSum += item.MaterialPriceWithWat * item.Count;
            }
          }

        }
      });
    }

    if (SonlandirData[0]?.WorkOrderLabours !== undefined) {
      SonlandirData[0].WorkOrderLabours.forEach((item, index) => {
        if (isPosTenant) {
          if (item.Price !== undefined && item.Price !== null && !isNaN(item.Price)) {
            currLabourSum += Math.round(item.Price * 100) / 100;
            currLabourVatSum += Math.round(item.PriceWithWat * 100) / 100;
          } else if (item.LabourPriceWithWat !== undefined && item.LabourPriceWithWat !== null && !isNaN(item.MaterialPriceWithWat)) {
            currLabourSum += Math.round(item.LabourPrice * 100) / 100;
            currLabourVatSum += Math.round(item.LabourPriceWithWat * 100) / 100;
          }
        }
        else {
          if (item.Price !== undefined && item.Price !== null && !isNaN(item.Price)) {
            currLabourSum += item.Price;
            currLabourVatSum += item.PriceWithWat;
          } else if (item.LabourPriceWithWat !== undefined && item.LabourPriceWithWat !== null && !isNaN(item.MaterialPriceWithWat)) {
            currLabourSum += item.LabourPrice;
            currLabourVatSum += item.LabourPriceWithWat;
          }
        }

      });
    }

    if (SonlandirData[0]?.WorkOrderTransport !== undefined) {
      SonlandirData[0].WorkOrderTransport.forEach((mrow, index) => {
        if (isPosTenant) {
          transportTotalWithWat += Math.round(mrow.MaterialPriceWithWat * 100) / 100;
          transportTotal += Math.round(mrow.MaterialPrice * 100) / 100;
        }
        else {
          transportTotalWithWat += mrow.MaterialPriceWithWat;
          transportTotal += mrow.MaterialPrice;
        }

      });
    }

    if (SonlandirData[0]?.WorkOrderExtra !== undefined) {
      SonlandirData[0].WorkOrderExtra.forEach((mrow, index) => {
        if (isPosTenant) {
          extraTotal += Math.round(mrow.MaterialPrice * 100) / 100;
          extraTotalWithWat += Math.round(mrow.MaterialPriceWithWat * 100) / 100;
        }
        else {
          extraTotal += mrow.MaterialPrice;
          extraTotalWithWat += mrow.MaterialPriceWithWat;
        }

      });
    }

  }

  const originalDiscountTotals = {
    labour: currLabourSum,
    material: currMaterialSum,
    transport: transportTotal,
    extra: extraTotal
  };

  if (manualDiscountTotals) {
    const applyDiscountedTotal = (original, originalWithVat, discounted) => ({
      net: discounted,
      withVat: original > 0 ? originalWithVat * discounted / original : discounted
    });
    const labour = applyDiscountedTotal(currLabourSum, currLabourVatSum, manualDiscountTotals.labour);
    const material = applyDiscountedTotal(currMaterialSum, currMaterialVatSum, manualDiscountTotals.material);
    const transport = applyDiscountedTotal(transportTotal, transportTotalWithWat, manualDiscountTotals.transport);
    const extra = applyDiscountedTotal(extraTotal, extraTotalWithWat, manualDiscountTotals.extra);
    currLabourSum = labour.net;
    currLabourVatSum = labour.withVat;
    currMaterialSum = material.net;
    currMaterialVatSum = material.withVat;
    transportTotal = transport.net;
    transportTotalWithWat = transport.withVat;
    extraTotal = extra.net;
    extraTotalWithWat = extra.withVat;
  }

  const openManualDiscountDialog = async () => {
    const hasUnsavedItems = localStorage.getItem('ManualDiscountWorkOrderDirty') === '1';
    if (hasUnsavedItems) {
      setUyari1('Please update the work order first.');
      setOpen(true);
      return;
    }
    const totals = manualDiscountTotals || originalDiscountTotals;
    setDiscountLabourTotal(totals.labour);
    setDiscountMaterialTotal(totals.material);
    setDiscountTransportTotal(totals.transport);
    setDiscountExtraTotal(totals.extra);
    setDiscountDetails([]);
    setDiscountSuccessMessage('');
    setDiscountErrorMessage('');
    try {
      const response = await axios.get(`/GetDawlanceShareFromWorkOrder/${parseInt(ReceiptNo)}`);
      let shareData = response.data;
      if (typeof shareData === 'string') shareData = JSON.parse(shareData);
      const shareRows = Array.isArray(shareData) ? shareData : [];
      const usedDetailIds = new Set();
      const hasUnmatchedItem = manualDiscountItems.some(item => {
        const matchingShare = shareRows.find(share => {
          const detailId = share.WorkOrderDetailId || share.workOrderDetailId;
          const materialId = share.MaterialId || share.materialId;
          if (!detailId || usedDetailIds.has(Number(detailId))) return false;
          return (item.workOrderDetailId && Number(detailId) === Number(item.workOrderDetailId))
            || (item.materialId && Number(materialId) === Number(item.materialId));
        });
        if (!matchingShare) return true;
        usedDetailIds.add(Number(matchingShare.WorkOrderDetailId || matchingShare.workOrderDetailId));
        return false;
      });
      if (hasUnmatchedItem) {
        setUyari1('Please update the work order first.');
        setOpen(true);
        return;
      }
      setDawlanceShares(shareRows);
      setShowManualDiscountDialog(true);
    } catch (error) {
      setresponseMessage({
        ErrorCode: '1',
        ErrorDescription: error?.response?.data?.message || 'Dawlance Share information could not be loaded.'
      });
      setUyariTip('error');
      setUyari(true);
    }
  };

  const openPaymentDetailsDialog = async () => {
    const hasUnsavedItems = localStorage.getItem('ManualDiscountWorkOrderDirty') === '1';
    if (hasUnsavedItems) {
      setUyari1('Please update the work order first.');
      setOpen(true);
      return;
    }
    try {
      setLoadingControl(true);
      const response = await axios.get(`/GetDawlanceShareFromWorkOrder/${parseInt(ReceiptNo)}`);
      let shareData = response.data;
      if (typeof shareData === 'string') shareData = JSON.parse(shareData);
      const shareRows = Array.isArray(shareData) ? shareData : [];
      const usedDetailIds = new Set();
      const hasUnmatchedItem = manualDiscountItems.some(item => {
        const matchingShare = shareRows.find(share => {
          const detailId = share.WorkOrderDetailId || share.workOrderDetailId;
          const materialId = share.MaterialId || share.materialId;
          if (!detailId || usedDetailIds.has(Number(detailId))) return false;
          return (item.workOrderDetailId && Number(detailId) === Number(item.workOrderDetailId))
            || (item.materialId && Number(materialId) === Number(item.materialId));
        });
        if (!matchingShare) return true;
        usedDetailIds.add(Number(matchingShare.WorkOrderDetailId || matchingShare.workOrderDetailId));
        return false;
      });
      if (hasUnmatchedItem) {
        setUyari1('Please update the work order first.');
        setOpen(true);
        return;
      }
      const paymentResponse = await axios.get(`/GetPaymentDetails/${parseInt(ReceiptNo)}`);
      let paymentData = paymentResponse.data;
      if (typeof paymentData === 'string') paymentData = JSON.parse(paymentData);
      setPaymentDetailsData(Array.isArray(paymentData) ? paymentData : []);
      setShowPaymentDetailsDialog(true);
    } catch (error) {
      setresponseMessage({
        ErrorCode: '1',
        ErrorDescription: error?.response?.data?.message || 'Payment Details could not be loaded.'
      });
      setUyariTip('error');
      setUyari(true);
    } finally {
      setLoadingControl(false);
    }
  };

  const parseDiscountValue = value => Math.max(0, parseFloat(value) || 0);
  const discountNewTotal = parseDiscountValue(discountLabourTotal)
    + parseDiscountValue(discountMaterialTotal)
    + parseDiscountValue(discountTransportTotal)
    + parseDiscountValue(discountExtraTotal);
  const discountOriginalTotal = Object.values(originalDiscountTotals)
    .reduce((total, value) => total + Math.round(value * 100) / 100, 0);
  const discountAmount = discountOriginalTotal - discountNewTotal;
  const discountRatio = discountOriginalTotal > 0 ? discountAmount / discountOriginalTotal * 100 : 0;

  const applyManualDiscount = () => {
    setDiscountErrorMessage('');
    const nextTotals = {
      labour: parseDiscountValue(discountLabourTotal),
      material: parseDiscountValue(discountMaterialTotal),
      transport: parseDiscountValue(discountTransportTotal),
      extra: parseDiscountValue(discountExtraTotal)
    };
    if (Math.abs(discountAmount) < 0.005 || discountDetails.length === 0) {
      setresponseMessage({ ErrorCode: '1', ErrorDescription: t('DiscountNoChangesError') });
      setUyariTip('warning');
      setUyari(true);
      return;
    }

    const employeeId = SessionUser?.TechnicianId || SessionUser?.EmployeeId;
    dispatch(applyManualDiscountRequest({
      workOrderId: parseInt(ReceiptNo),
      newLabourTotal: nextTotals.labour,
      newSparePartTotal: nextTotals.material,
      newTransportTotal: nextTotals.transport,
      newExtraTotal: nextTotals.extra,
      employeeId,
      warrantor: null,
      paymentTypeId: null,
      paymentTypeDetail: null,
      details: discountDetails
    })).unwrap().then(response => {
      let discountResponse = response;
      if (typeof discountResponse === 'string') {
        try {
          discountResponse = JSON.parse(discountResponse);
        } catch (error) {
          discountResponse = { Message: response };
        }
      }
      const successMessage = discountResponse?.Message
        || discountResponse?.message
        || discountResponse?.data?.Message
        || discountResponse?.data?.message
        || t('DiscountSuccess');

      setManualDiscountTotals(nextTotals);
      setDiscountSuccessMessage(successMessage);
    }).catch(error => {
      setDiscountErrorMessage(
        typeof error === 'string'
          ? error
          : (error?.Message || error?.message || t('DiscountError'))
      );
    });
  };

  const getCompensation = () => {
    axios
      .get(
        `/GetCompensationSS/${ReceiptNo || 0}`
      )
      .then(response => {
        if (response.data.length > 0 && response.data != "") {
          setCompensation(response.data);
          setManufacturingFault(response.data[0].ManufacturingFault);
        } else {
          setCompensation([]); //no data
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };


  useEffect(() => {
    var UserTypeId = SessionUser.TechnicianId;
    var OldStatusId = SonlandirData[0]?.LatestStatus;
    axios
      .get(
        '/GetWorkOrderStatusLogic/' +
        OldStatusId +
        '/' +
        UserTypeId +
        '/' +
        ReceiptNo
      )
      .then(response => {
        const Deger = response.data;
        setStatusData(Deger);

        setSelectedMobileStatus(Deger.find(i => i.StatusId == SonlandirData[0].LatestStatus)?.MobileStatusId);



        setLoadingControl(false);
      })
      .catch(error => {
        setStatusData([]);
        setLoadingControl(false);
      });
    setSonDurum(SonlandirData[0]?.LatestStatus || '0');
  }, [SessionUser.ServiceShopId]);

  useEffect(() => {
    GetLocation();
    if (SonlandirData === undefined || SonlandirData[0] === undefined) {
      return;
    }
    setIslemYeri(SonlandirData[0]?.OperationPlaceId || '0');
    setTahsilatGoster(true);
    setTahsilatTipi(SonlandirData[0]?.PaymentTypeId || 0);
    setReworkDurum(SonlandirData[0]?.ReworkId || 0);
    setSonucNotu(SonlandirData[0]?.StatusNote || '');
    setProjeKodu(SonlandirData[0]?.ProjectCode || '');
    SetUsedNotUsedData(SonlandirData[0]?.WorkOrderMaterials || []);
    setTutar(SonlandirData[0]?.DiscountAmountTotal || 0);
    setSourceOfDefect(SonlandirData[0]?.SourceOfDefect || 0);
    setRequired(SonlandirData[0]?.IsStatusNoteRequired);
    setIsStatusNoteRequired(SonlandirData[0]?.IsStatusNoteRequired);
    if (SonlandirData[0]?.WorkOrderTransport.length > 0) {
      setTotalTransportPrice(
        SonlandirData[0]?.WorkOrderTransport[0]?.MaterialPrice
      );
    } else {
      setTotalTransportPrice(0);
    }

    setLoadingControl(true);
  }, []);

  useEffect(() => {
    GetActivePaymentTypes();
    GetActiveReworkStatus();
    GetRefurbishmentGrade();
    GetSourceOfDefectTypes();
    GetPlace();
    GetWarranty();
    getCompensation();
    CancellationReasons();
    GetTenantDiscountCondition();
    dispatch(paymentThunks.GetRepairOrderCondition());
    dispatch(paymentThunks.GetPosTenantVatRate());
  }, []);

  useEffect(() => {
    if (uyari)
      setisButtonDisabled2(false);
  }, [uyari]);


  const warrantyGroupId = WarrantyTypeId[0]?.WarrantyGroupId;
  useEffect(() => {
    console.log(WarrantyTypeId[0])
    console.log("Warranty Group ID:", warrantyGroupId, "Tahsilat Tipi:", tahsilatTipi, "RepairOrderConditions:", repairOrderConditions);
    if (repairOrderConditions.length > 0) {
      // Backend'den gelen koşullara göre ödeme butonu aktif/pasif yapılıyor
      const match = repairOrderConditions.some(
        c => c.Active && c.WarrantyGroupId === warrantyGroupId && c.PaymentTypeId === parseInt(tahsilatTipi)
      );
      setPayButtonActive(match);
    } else {
      setPayButtonActive(false);
    }
  }, [warrantyGroupId, tahsilatTipi, repairOrderConditions]);



  const handleChangeDurum = event => {
    setRequired(StatusData.filter(i => i.StatusId == event.target.value)[0].IsStatusNoteRequired);
    setIsStatusNoteRequired(StatusData.filter(i => i.StatusId == event.target.value)[0].IsStatusNoteRequired);
    setIsAI(StatusData.filter(i => i.StatusId == event.target.value)[0].IsAI);
    var MobileStatusId = StatusData.filter(i => i.StatusId == event.target.value)[0].MobileStatusId
    setSelectedMobileStatus(MobileStatusId)
    let job = SonlandirData[0];

    job = {
      ...job,
      LatestStatus: event.target.value,
      LatestStatusMobileId: MobileStatusId,
      StatusNote: '',
      IsStatusNoteRequired: StatusData.filter(i => i.StatusId == event.target.value)[0].IsStatusNoteRequired
    };
    setTask(job);
    setSonucNotu('');
    setSonDurum(event.target.value);
  };



  const handleChangeSourceOfDefect = event => {
    let job = SonlandirData[0];
    job = {
      ...job,
      SourceOfDefect: event.target.value
    };
    setTask(job);
    setSourceOfDefect(event.target.value);
  };


  const handleChangeIslemYeri = event => {
    let job = SonlandirData[0];
    job = {
      ...job,
      OperationPlaceId: event.target.value
    };
    setTask(job);
    setIslemYeri(event.target.value);
  };

  const handleChangeTahsilatTipi = event => {
    if (readonly) {
      return;
    }
    let job = SonlandirData[0];
    job = {
      ...job,
      PaymentTypeId: event.target.value
    };
    setTask(job);
    setTahsilatTipi(event.target.value);
  };

  const handleChangeRework = event => {
    if (readonly) {
      return;
    }
    let job = SonlandirData[0];
    job = {
      ...job,
      ReworkId: event.target.value
    };
    setTask(job);
    setReworkDurum(event.target.value);
  };
  const handleChangeRefurbishment = event => {
    if (readonly) {
      return;
    }
    let job = SonlandirData[0];
    job = {
      ...job,
      RefurbishmentId: event.target.value
    };
    setTask(job);
    SetRefurbishmentId(event.target.value);
  };
  const handleChangeSonucNotu = event => {
    if (readonly) {
      return;
    }
    if (openLegal === false) {
      setOpenLegal(true);
    }

    let job = SonlandirData[0];
    job = {
      ...job,
      Notes: event.target.value
    };
    setTask(job);
    setSonucNotu(event.target.value);


    if (event.target.value.length < 5 && IsStatusNoteRequired) {

      setRequired(true);
      job = {
        ...job,
        IsStatusNoteRequired: true
      };
      setTask(job);
    }
    else {
      setRequired(false);

      job = {
        ...job,
        IsStatusNoteRequired: false
      };
      setTask(job);

    }
  };
  const handleChangeCompressorNumber = event => {
    if (readonly || SessionUser.TenantId != 75) {
      return;
    }
    const { name, value } = event.target;
    if (name !== 'CustomerErrorCode' && name !== 'ServiceErrorCode') {
      return;
    }
    setTask({
      ...SonlandirData[0],
      [name]: value
    });
  };
  const handleChangeProjeKodu = event => {
    if (readonly) {
      return;
    }
    let job = SonlandirData[0];
    job = {
      ...job,
      ProjectCode: event.target.value
    };
    setTask(job);
    setProjeKodu(event.target.value);
  };
  const handleMerkezeGonderPopup0 = (event, CloseType) => {
    confirmAlert({
      message: t('Update_warning'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => handleMerkezeGonderEvet(event, CloseType)
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }

      ]
    });
  };

  // handleMerkezeGonder means send SendToCenter which can be
  // translated into like updateWorkOrder
  // we are updating the work order in with that function
  // but first we are checking some data from the backend side
  const handleMerkezeGonder = (event, CloseType) => {
    const filteredData = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    if (filteredData[0].IsStatusNoteRequired) {

      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: ('Status Note is Required.')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      setOpen(true);
      setUyari1(('Status Note is Required.'));
      return;
    }

    setisButtonDisabled2(false);
    setLoadingControl(true);
    axios
      .get(`/GetClosePopupControl/` + parseInt(sonDurum))
      .then(response => {
        if (parseInt(response.data) === 0) {
          handleMerkezeGonderPopup0(event, CloseType);
        }
        if (parseInt(response.data) === 1) {
          setClosePopupHeader(t('lblClosePopup1'));
          setCloseBtn1(t('lblCloseBtn1'));
          setCloseBtn2(t('lblCloseBtn2'));
          setCloseTypePopupControl1(1);
          setCloseTypePopupControl2(2);
          setClosePopupControl(true);
        }
        if (parseInt(response.data) === 2) {
          setClosePopupHeader(t('lblClosePopup2'));
          setCloseBtn1(t('lblCloseBtn5'));
          setCloseBtn2(t('lblCloseBtn6'));
          setCloseTypePopupControl1(5);
          setCloseTypePopupControl2(6);
          setClosePopupControl(true);
        }
        if (parseInt(response.data) === 3) {
          if (SonlandirData[0]?.WorkOrderMaterials?.length > 0 && SessionUser.TenantId != 37 && SessionUser.TenantId != 70 && SessionUser.TenantId != 75) {
            setOpenUsedNotUsedDialog(true);
          } else {
            setOpenUsedNotUsedDialog(false);
            setClosePopupControl(true);
            checkAll();
          }
          setClosePopupHeader(t('lblClosePopup3'));
          setCloseBtn1(t('lblCloseBtn3'));
          setCloseBtn2(t('lblCloseBtn4'));
          setCloseTypePopupControl1(3);
          setCloseTypePopupControl2(4);
          // setClosePopupControl(true);
        }
        setLoadingControl(false);
      })
      .catch(error => {
        setLoadingControl(false);
      });
  };


  const handleMerkezeGonderEvet = async (event, CloseType) => {

    if (CloseType === 2) {
      setClosePopupControl(false);
      return;
    }
    if (CloseType === 4) {
      setClosePopupControl(false);
      return;
    }
    if (localStorage.getItem('UpdateButtonMaterialControl') !== undefined) {
      if (parseInt(localStorage.getItem('UpdateButtonMaterialControl')) === 0) {
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblButtonControlMaterial'));
        return;
      }
    }
    if (localStorage.getItem('UpdateButtonDefectControl') !== undefined) {
      if (parseInt(localStorage.getItem('UpdateButtonDefectControl')) === 0) {
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblButtonControlDefect'));
        return;
      }
    }
    if (localStorage.getItem('UpdateButtonLabourControl') !== undefined) {
      if (parseInt(localStorage.getItem('UpdateButtonLabourControl')) === 0) {
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblButtonControlLabour'));
        return;
      }
    }
    setisButtonDisabled2(true);
    try {
      setLoadingControl(true);
      const StatusId = parseInt(sonDurum);
      await uploadFotograf(ReceiptNo);
      const MerkezeGonderilecekData = tasks.tasks.filter(d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
      const StatusLatitude = getKoordinat('Enlem');
      const StatusLongitude = getKoordinat('Boylam');

      const TechnicianStatusControl = StatusData.filter(x => x.StatusId === StatusId);

      const Control = TechnicianStatusControl[0]?.MobileStatusId;

      if (
        (parseInt(MerkezeGonderilecekData[0].EmployeeId) || 0) === 0 &&
        Control === 21
      ) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustTechnician')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblMustTechnician'));
        return;
      }

      // Status Assigned ise Not girilmemesine izin veriyoruz
      if (IsStatusNoteRequired && selectedMobileStatus !== 3) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setRequired(true);
        setUyari1(t('lblMustFieldControl'));
        return;
      }
      if (selectedMobileStatus == 3 && (parseInt(MerkezeGonderilecekData[0].ServiceShopId) || 0) === 0) {
        //Assigned ama servis seçili değil
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblSelectServiceToAssign')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setRequired(true);
        setUyari1(t('lblSelectServiceToAssign'));
        return;
      }
      if (selectedMobileStatus == 21 && (parseInt(MerkezeGonderilecekData[0].EmployeeId) || 0) === 0) {
        //At Technician ama technician seçili değil
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblSelectTechnicianToAssign')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setRequired(true);
        setUyari1(t('lblSelectTechnicianToAssign'));
        return;
      }
      // if (selectedMobileStatus == 21 && (parseInt(MerkezeGonderilecekData[0].AppointmentDate) || null) === null) {
      //   //At Technician ama Appointment Date Boş
      //   setresponseMessage({
      //     ErrorCode: 10,
      //     ErrorDescription: t('lblSelectAppointmentDate')
      //   });
      //   setUyariTip('error');
      //   setUyari(true);
      //   setOpen(true);
      //   setRequired(true);
      //   setUyari1(t('lblSelectAppointmentDate'));
      //   return;
      // }
      if (selectedMobileStatus == 24 && (parseInt(MerkezeGonderilecekData[0].AppointmentDate) || null) === null) {
        //Appointment made ama Appointment Date Boş
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblAppointmentDateSelect')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setRequired(true);
        setUyari1(t('lblAppointmentDateSelect'));
        return;
      }
      if (selectedMobileStatus == 3 && (parseInt(MerkezeGonderilecekData[0].ConsumerAddressId) || 0) === 0) {
        //Assigned ama Adres boş
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblAppointmentAddress')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setRequired(true);
        setUyari1(t('lblAppointmentAddress'));
        return;
      }

      // if (selectedMobileStatus == 11 && MerkezeGonderilecekData[0].PotentialLiabiltiy == 1 && ManufacturingFault == '') {
      //   //Selected New Visit Required and click potential liability claim but compensation form is empty
      //   //(we can understand if manufacturingfault is empty then compensation form is not filled because it is a mandatory)
      //   setresponseMessage({
      //     ErrorCode: 10,
      //     ErrorDescription: t('lblCompensationError')
      //   });
      //   setUyariTip('error');
      //   setUyari(true);
      //   setOpen(true);
      //   setRequired(true);
      //   setUyari1(t('lblCompensationError'));
      //   return;
      // }

      if (MerkezeGonderilecekData[0]?.FormRequired == 1 && ManufacturingFault == '') {
        //If FormRequired is true but compensation form is empty.
        //(we can understand if manufacturingfault is empty then compensation form is not filled because it is a mandatory)
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblCompensationError')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setRequired(true);
        setUyari1(t('lblCompensationError'));
        return;
      } else {
        if (selectedMobileStatus == 9 && MerkezeGonderilecekData[0]?.Confirmed == 0) {
          //You cannot update if the form is mandatory and not confirmed.
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('lblConfirmedError')
          });
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setRequired(true);
          setUyari1(t('lblConfirmedError'));
          return;
        }
      }

      // Specific Romanian Rule
      // If Repair Completed Status in Serbia is Repair Completed
      // And Status Note is empty then it will throw an error
      if (StatusId === 664 && (SonucNotu == '' || SonucNotu == undefined)) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('Special Serbia Error, you need to fill Status Note')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('Please fill Status Note'));
        return;
      }

      if (IsAI === true) {
        AIPrediction();
        setOpenAIDialog(true);
        return;
      }


      if (CloseType === 5) {
        setClosePopupControl(false);
        setOpenCancellationPopup(true);
        return;
      }
      if (CloseType === 8) {
        const dataBody = {
          WorkCaseId: parseInt(MerkezeGonderilecekData[0].WorkCaseId) || 0,
          CancellationNote: event?.CancellationNote,
          CancellationReasonId: event?.CancellationReasonId,
        }
        const dataConfigCancellation = {
          headers: { 'Content-Type': 'application/json' }
        };
        axios
          .post('/SetWorkCaseCancellation', dataBody, dataConfigCancellation)
          .then(response => {
            const res = response.data.length === 0 ? [] : response.data;
            if (res[0].ErrorCode === 0) {
              setresponseMessage({
                ErrorCode: 10,
                ErrorDescription: t('success_message')
              });
              setUyariTip('success');
              setUyari(true);
              setOpenCancellationPopup(false);
            }
          })
          .catch(error => {
            setresponseMessage({
              ErrorCode: 10,
              ErrorDescription: t('lblErrorMessage')
            });
            setUyariTip('error');
            setUyari(true);
          });
      }
      //Used Unused Material Work Start
      if (CloseType === 3) {
        let filterWorkOrderMaterials = []
        let oldValues = []
        if (MerkezeGonderilecekData[0]?.WorkOrderMaterials?.length > 0) {
          MerkezeGonderilecekData[0].WorkOrderMaterials.forEach((mrow, index) => {
            let Count = 0;
            let CountMaterial = 0
            cloneArray.forEach((irow, iindex) => {
              if (mrow.DefectId === irow.DefectId && mrow.MaterialId === irow.MaterialId && irow.is_selected === true) {
                Count++;
                CountMaterial++
              }
            })
            if (CountMaterial == 0) {
              delete materialReducer[mrow.MaterialCode]
              const selected = materialReducer[mrow.DefectId]
              const deleteIndex = selected.indexOf(mrow.MaterialCode)
              materialReducer[mrow.DefectId].splice(deleteIndex, 1)
            } else {
              materialReducer[mrow.MaterialCode] = CountMaterial
              CountMaterial = 0;
            }
            if (Count > 0) {
              filterWorkOrderMaterials.push({
                Count: Count,
                DefectId: mrow.DefectId,
                DefectDesc: mrow.DefectDesc,
                MaterialCode: mrow.MaterialCode,
                MaterialDesc: mrow.MaterialDesc,
                MaterialId: mrow.MaterialId,
                MaterialPriceId: mrow.MaterialPriceId,
                MaterialPriceListId: mrow.MaterialPriceListId,
                Price: mrow.Price,
                PriceWithWat: mrow.PriceWithWat,
                VatId: mrow.VatRateId,
                VatRate: mrow.VatRate
              })
            }

          })
        }
        MerkezeGonderilecekData.WorkOrderMaterials = filterWorkOrderMaterials
      }


      //Used Unused Material Work End
      const data = [
        {

          WorkOrderId: parseInt(MerkezeGonderilecekData[0].ReceiptNo) || 0,
          WorkCaseId: parseInt(MerkezeGonderilecekData[0].WorkCaseId) || 0,
          ServiceShopId:
            parseInt(MerkezeGonderilecekData[0].ServiceShopId) || 0,
          ConsumerId: parseInt(MerkezeGonderilecekData[0].ConsumerId) || 0,
          ConsumerAddressId:
            parseInt(MerkezeGonderilecekData[0].ConsumerAddressId) || 0,
          ContactName: MerkezeGonderilecekData[0].ContactName || '',
          ContactPhone: MerkezeGonderilecekData[0].ContactPhone || '',
          EmployeeId: parseInt(MerkezeGonderilecekData[0].EmployeeId) || 0,
          ModelCode: MerkezeGonderilecekData[0].ModelCode || '',
          ProductionYear:
            parseInt(MerkezeGonderilecekData[0].ProductionYear) || 0,
          ProductionMonth:
            parseInt(MerkezeGonderilecekData[0].ProductionMonth) || 0,
          SerialNumber: MerkezeGonderilecekData[0].SerialNumber || '0',
          AttributeId: parseInt(MerkezeGonderilecekData[0].AttributeId) || 0,
          WarrantyDate: MerkezeGonderilecekData[0].WarrantyDate || '',
          WarrantyTypeId:
            parseInt(MerkezeGonderilecekData[0].WarrantyTypeId) || 0,
          LatestStatus: parseInt(MerkezeGonderilecekData[0].LatestStatus) || 4,
          OperationPlaceId:
            parseInt(MerkezeGonderilecekData[0].OperationPlaceId) || 0,
          Notes: MerkezeGonderilecekData[0].Notes || '',
          StatusLatitude: StatusLatitude || '',
          StatusLongitude: StatusLongitude || '',
          IssueId: MerkezeGonderilecekData[0].IssueId || '',
          RetailerId: MerkezeGonderilecekData[0].RetailerId || 0,
          PaymentTypeId:
            parseInt(MerkezeGonderilecekData[0].PaymentTypeId) || 0,
          ReworkId:
            parseInt(MerkezeGonderilecekData[0].ReworkId) || 0,
          RefurbishmentId:
            parseInt(MerkezeGonderilecekData[0].RefurbishmentId) || 0,
          DiscountAmountTotal:
            MerkezeGonderilecekData[0].DiscountAmountTotal || 0,
          ProjectCode: MerkezeGonderilecekData[0].ProjectCode || '',
          ...(SessionUser.TenantId == 75 ? {
            CustomerErrorCode: MerkezeGonderilecekData[0].CustomerErrorCode || '',
            ServiceErrorCode: MerkezeGonderilecekData[0].ServiceErrorCode || ''
          } : {}),
          UpdateUserId: parseInt(SessionUser.TechnicianId) || 0,
          CloseType,
          ChannelId: parseInt(MerkezeGonderilecekData[0].ChannelId) || 1,
          AppointmentDate: MerkezeGonderilecekData[0].AppointmentDate || '',
          AppointmentEndDate:
            MerkezeGonderilecekData[0].AppointmentEndDate || '',
          PriorityId: parseInt(MerkezeGonderilecekData[0].PriorityId) || 1,
          UrgentCustomer: MerkezeGonderilecekData[0].UrgentCustomer || 0,
          PotentialLiabiltiy: MerkezeGonderilecekData[0].PotentialLiabiltiy || 0,
          NoInvoice: MerkezeGonderilecekData[0].NoInvoice || false,
          SourceOfDefect: MerkezeGonderilecekData[0].SourceOfDefect || 0,
          PreferredDate: MerkezeGonderilecekData[0].PreferredDate || '',
          Defects: (MerkezeGonderilecekData[0].WorkOrderDetails || []).map(h => { return { DefectId: h.DefectId }; }) || [],
          Labours: MerkezeGonderilecekData[0].WorkOrderLabours || [],
          Materials: MerkezeGonderilecekData[0].WorkOrderMaterials || [],
          DistributorId: MerkezeGonderilecekData[0].DistributorId || 0,
          TaskTypeId: MerkezeGonderilecekData[0].TaskTypeId || 0,
          Barcode: MerkezeGonderilecekData[0].Barcode || '',
          UsedNotUsedMaterialData: cloneArray || [],
          DiscountTypeId: MerkezeGonderilecekData[0].DiscountTypeId || 0,
          DiscountRateId: MerkezeGonderilecekData[0].DiscountRateId || 0,
          BillingConsumer: MerkezeGonderilecekData[0].BillingConsumer || [],
        }
      ];

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      axios
        .post('/SetWorkOrderUpdate', data, config)
        .then(response => {
          setLoadingControl(false);
          setClosePopupControl(false);

          const ResponseData = response.data[0];
          if (parseInt(ResponseData.ErrorCode) !== 0) {
            setOpenResponse(true);
            setResponseData(ResponseData.ErrorDescription.split('|'));
          } else {
            localStorage.setItem('ManualDiscountWorkOrderDirty', '0');
            getTasksRequest(parseInt(MerkezeGonderilecekData[0].ReceiptNo));
            setisButtonDisabled(true);
            setresponseMessage({
              ErrorCode: 0,
              ErrorDescription: ResponseData.ErrorDescription
            });
            setUyariTip('success');
            setUyari(true);
            setOpen(true);
            setUyari1(ResponseData.ErrorDescription);


            if (ResponseData?.OrderId > 0) {
              setMaterialOrderId(ResponseData?.OrderId);
              isCancelledRef.current = false;
              setOpenMaterialOrder(true);
            } else {
              setMaterialOrderId(0);
              setOpenMaterialOrder(false);
            }
            setTimeout(() => setisButtonDisabled(false), 5000);
            setisButtonDisabled2(false);
          }
        })
        .catch(error => {
          setLoadingControl(false);
          setClosePopupControl(false);
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('Offline_warning')
          });
          setUyariTip('error');
          setUyari(true);
        });
    } catch (error) {
      setLoadingControl(false);
      setClosePopupControl(false);
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Offline_warning')
      });
      setUyariTip('error');
      setUyari(true);
    }

  };
  const handleStatusChangeText = event => {
    setSonDurumAciklama(event.target.innerText);
  };

  function GetMaterialOrderSAPCountry() {
    axios
      .post('/GetMaterialOrderSAPCountry/' + SessionUser.TenantId)
      .then(response => {
        if (response.data) {
          if (OrderNr !== '' && OrderNr !== undefined) {
            CreateOrderInSap(OrderNr);
          } else {
            CreateOrderInSap(MaterialOrderId);
          }
        }
      });
  }

  function CreateOrderInSap(MaterialOrderId) {
    axios
      .post('/CreateOrderInSAP/' + MaterialOrderId)
      .then(response => {
        if (response.data.ErrorCode == 1000) {
          setresponseMessage({
            ErrorCode: response.data.ErrorCode,
            ErrorDescription: response.data.ErrorMessage
          });
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setUyari1(responseMessage.ErrorDescription);
          return;
        }
      });
  }

  function handleCloseDialog() {
    setOpenMaterialOrder(false);
    if (SessionUser.TenantId != 64 && !isCancelledRef.current) {
      GetMaterialOrderSAPCountry();
    }
  }
  const handleCloseCancellationPopup = () => {
    setOpenCancellationPopup(false);
  };

  //Used UnUsed Work Start

  const [cloneArray, setCloneArray] = useState([])

  const duplcatingArray = () => {
    let itemArray = [];
    const change = SonlandirData[0]?.WorkOrderMaterials.map((data) => (
      Array.from({ length: data?.Count }, (v, i) => {
        itemArray.push(data)
      })
    ))
    const duplicatedArray = itemArray.map((item) => ({ ...item, is_selected: null }))
    setCloneArray(duplicatedArray)
  }

  function checkSelection({ index, value, id }) {
    const newValue = cloneArray.map((item, key) => {
      if (key === index) {
        item.is_selected = value;
      }
      return item;
    })
    setCloneArray(newValue);
  }
  const checkAll = () => {
    const updatedItems = cloneArray.map(item => ({
      ...item,
      is_selected: true,
    }));
    setCloneArray(updatedItems);
  };

  const clearUnusedItemsCheckBox = () => {
    const newValue = cloneArray.map((data) => ({ ...data, is_selected: null }))
    setCloneArray(newValue)
  }
  const handleSelectedUnusedItems = () => {
    let count = 0;
    cloneArray.map((data) => {
      if (data.is_selected === null) {
        count = 1
      }

    })

    if (count > 0 && OpenUsedNotUsedDialog) {
      setError(true)
    } else {
      setError(false)
      setOpenUsedNotUsedDialog(false)
      setOpenMaterialOrder(false)
      setClosePopupControl(true);
    }
  }


  useEffect(() => {
    duplcatingArray()
  }, [SonlandirData[0]?.WorkOrderMaterials])

  //Used UnUsed Work End

  function currencyFormat(num) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }


  async function AIPrediction() {
    setLoadingControl(true);
    var row = SonlandirData[0];

    const predictionRequest = {
      BASVURU_NEDENI: row.IssueReason,
      BASVURU_NOTU: row.CallCenterNote === null ? '' : row.CallCenterNote,
      FIS_NO: row.ReceiptNo,
      MODEL_KODU: row.MappingModelCode,
      SF_ACIKLAMA: ""
    };

    axiosHeadOffice
      .post('/AIPrediction', predictionRequest)
      .then(result => {
        var response = result.data.Response;
        var responsePredictions = result.data.TAHMINLER;

        if (response.ErrorCode !== '1000') {
          setPredictions(responsePredictions);
          AIDefectsAndMaterials(responsePredictions);
        } else {
          setPredictions([]);
          setresponseMessage({
            ErrorCode: response.ErrorCode,
            ErrorDescription: response.ErrorDescription
          });
        }
      });
    setLoadingControl(false);
  }

  async function AIDefectsAndMaterials(predictions) {
    setDefectsAndMaterials([]);
    setLoadingControl(true);

    const DefectCodes = predictions.map(p => p.HIZMET_KODU);
    const MaterialCodes = predictions.map(p => p.MALZEME_KODU);

    const data = {
      HIZMET_KODU: DefectCodes,
      MALZEME_KODU: MaterialCodes
    };

    axiosHeadOffice
      .post('/GetAIPredictionDefectAndMaterial', data)
      .then(values => {
        if (values.data?.length > 0) {
          var filteredData = values.data;
          setDefectsAndMaterials(filteredData.map((d) => ({
            DefectId: d.DefectId,
            DefectCode: d.DefectCode,
            Defect: d.Defect,
            CategoryLevel2: d.CategoryLevel2,
            DefectType: d.DefectType,
            DefectTypeCode: d.DefectTypeCode,
            MaterialId: d.MaterialId,
            MaterialCode: d.MaterialCode,
            MaterialDsc: d.MaterialDsc
          })));
        } else {
          setDefectsAndMaterials([]);
        }
      });
    setLoadingControl(false);
  }

  function TriagePreorderOperations(isOrder) {
    setLoadingControl(true);

    const data = matchedPairs.length > 0 ? matchedPairs.map(pair => ({
      WorkOrderId: ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo,
      DefectId: pair.defect.DefectId,
      MaterialId: pair.material.MaterialId,
      IsOrder: isOrder,
      EmployeeId: SessionUser.TechnicianId
    })) :
      [{
        WorkOrderId: ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo,
        DefectId: 0,
        MaterialId: 0,
        IsOrder: isOrder,
        EmployeeId: SessionUser.TechnicianId
      }];


    axiosHeadOffice
      .post('/TriagePreorderOperations', data)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setOpen(true);
          setUyari1(t('lblSuccess') + ' - ' + response.data.ErrorDescription);
          setOpenAIDialog(false);
          getTasksRequest(parseInt(SonlandirData[0].ReceiptNo));
        }
        else if (response.data.ErrorCode === "10") {
          setOpen(true);
          setUyari1(isOrder ? t('lblTriageOperationMsg') : t('lblWithoutOrderTip'));
          setOpenAIDialog(false);
          getTasksRequest(parseInt(SonlandirData[0].ReceiptNo));
        }
        else if (response.data.ErrorCode === "1000") {
          setOpen(true);
          setUyari1(response.data.ErrorDescription);
        }
      });
    setLoadingControl(false);
  }

  const handleDefectSelect = (defect) => {
    setSelectedDefect(defect);
    setSelectedMaterial(null);
  };

  const handleMaterialSelect = (material) => {
    setSelectedMaterial(material);
  };

  const handleMatch = () => {
    if (selectedDefect && selectedMaterial) {
      setMatchedPairs([...matchedPairs, { defect: selectedDefect, material: selectedMaterial }]);
      setSelectedDefect(null);
      setSelectedMaterial(null);
    }
  };

  const handleDeleteMatchedPair = (index) => {
    const updatedMatchedPairs = [...matchedPairs];
    updatedMatchedPairs.splice(index, 1);
    setMatchedPairs(updatedMatchedPairs);
  };


  function GetDefectsAndMaterialsByWorkOrderId() {
    setLoadingControl(true);

    axiosHeadOffice
      .get('/GetDefectsAndMaterialsByWorkOrderId/' + ReceiptNo)
      .then(response => {
        if (response.data.length > 0) {
          setDefectAndMaterialList(response.data);
        } else {
          setDefectAndMaterialList([]);
        }
      });
    setLoadingControl(false);
  }

  useEffect(() => {
    if (OpenAIDialog === true)
      GetDefectsAndMaterialsByWorkOrderId();
  }, [OpenAIDialog]);


  function handleAddMatchedPairs(newDefect, newMaterial) {
    if (newDefect !== undefined) {
      setMatchedPairs([...matchedPairs, {
        defect: { Defect: newDefect.DefectDesc, DefectCode: newDefect.UserCode, DefectId: newDefect.Code },
        material: { MaterialCode: newMaterial.MaterialCode, MaterialDsc: newMaterial.MaterialDesc, MaterialId: newMaterial.MaterialId }
      }]);
    }
  }

  const hasMaterialAndDefect = matchedPairs.some(pair => pair.material && pair.defect);

  const getOrderNr = (orderNr) => {
    if (orderNr !== undefined) {
      setOrderNr(orderNr);
    }
  };

  const handleCloseTriageMaterialOrder = () => {
    if (OrderNr === '' || OrderNr === undefined) {
      setOpen(true);
      setUyari1(t('lblObligationOrderMsg'));
    } else {
      setOpenTriageMaterialOrder(false);
      if (SessionUser.TenantId != 64) {
        GetMaterialOrderSAPCountry();
      }
    }
  };

  // Payment - RepairPreSale handlers
  const totalWithVat = currMaterialVatSum + currLabourVatSum + transportTotalWithWat + extraTotalWithWat;
  const paymentCur = SessionUser.CurrencyUnit || '';
  const paymentIframeUrl = repairData?.PaymentUrl;

  const handleOpenPaymentDialog = () => {
    setPaymentLocalError('');
    setShowPaymentIframe(false);
    dispatch(paymentActions.clearRepairPreSale());
    // Fetch POS machines
    const employeeId = parseInt(SessionUser?.TechnicianId) || 0;
    if (employeeId > 0) {
      dispatch(paymentThunks.GetEmployeePosMatching(employeeId));
    }
    debugger
    console.log(SessionUser);
    setShowPaymentDialog(true);
  };

  const handleClosePaymentDialog = () => {
    setShowPaymentDialog(false);
    setShowPaymentIframe(false);
    setSelectedPos('');
    dispatch(paymentActions.clearRepairPreSale());
    dispatch(paymentActions.clearEmployeePosMatching());
  };

  const GetSiriusPricingInfos = () => {
    const products = [];
    let roundedTotal = 0;
    const job = SonlandirData[0];
    if (!job) return products;

    (job.WorkOrderMaterials || []).forEach(material => {
      const roundedPrice = Math.round((material.PriceWithWat || 0) * 100) / 100;
      const qty = material.Count || 1;
      roundedTotal += roundedPrice * qty;
      products.push({
        Um: 'pcs',
        Name: material.MaterialDesc,
        ProductId: material.MaterialId,
        ProductSku: material.MaterialCode,
        Price: roundedPrice.toString() || '0',
        VatId: "A",
        Quantity: String(qty)
      });
    });

    (job.WorkOrderLabours || []).forEach(labour => {
      const roundedPrice = Math.round((labour.PriceWithWat || 0) * 100) / 100;
      roundedTotal += roundedPrice;
      products.push({
        Um: 'pcs',
        Name: labour.LabourDesc,
        ProductId: labour.LabourId,
        ProductSku: labour.LabourCode,
        Price: roundedPrice.toString() || '0',
        VatId: "A",
        Quantity: '1'
      });
    });

    (job.WorkOrderTransport || []).forEach(transport => {
      const roundedPrice = Math.round((transport.MaterialPriceWithWat || 0) * 100) / 100;
      roundedTotal += roundedPrice;
      products.push({
        Um: 'pcs',
        Name: 'Transport',
        ProductId: transport.Id || 0,
        ProductSku: '',
        Price: roundedPrice.toString() || '0',
        VatId: "A",
        Quantity: '1'
      });
    });

    (job.WorkOrderExtra || []).forEach(extra => {
      const roundedPrice = Math.round((extra.MaterialPriceWithWat || 0) * 100) / 100;
      roundedTotal += roundedPrice;
      products.push({
        Um: 'pcs',
        Name: 'Extra Cost',
        ProductId: extra.Id || 0,
        ProductSku: '',
        Price: roundedPrice.toString() || '0',
        VatId: "A",
        Quantity: '1'
      });
    });

    return { products, roundedTotal };
  };

  const handleRepairPreSale = () => {
    setPaymentLocalError('');
    setShowPaymentIframe(false);
    dispatch(paymentActions.clearRepairPreSale());

    const { products, roundedTotal } = GetSiriusPricingInfos();

    const dto = {
      ApplicationReference: String(ReceiptNo || ''),
      Amount: roundedTotal,
      Currency: paymentCur.toUpperCase() || 'RON',
      UserRef: selectedPos || '',
      Products: products,
      AdditionalMetaData: '',
      LanguageCode: '',
      CreateEmployeeId: null,
      ConsumerId: null
    };

    dispatch(paymentThunks.RepairPreSale(dto))
      .then(resp => {
        const payload = resp?.payload;
        if (resp?.error) {
          setPaymentLocalError(resp.error.message || 'RepairPreSale failed.');
          return;
        }
        if (payload?.PaymentUrl) {
          setShowPaymentIframe(true);
        }
      })
      .catch(err => {
        setPaymentLocalError(err?.message || 'RepairPreSale exception.');
      });
  };

  return (
    <Card className={classes.cardsMax}>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Snackbar
        open={openLegal}
        autoHideDuration={10000}
        onClose={handleCloseopenLegal}
      >
        <Alert
          onClose={handleCloseopenLegal}
          message={t('saglik_bilgisi_warning')}
          variant="success"
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={LoadingControl}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <CardHeader title={t('Sonlandir')} />
      <Divider />
      <CardContent className={classes.content}>
        <form className={clsx(classes.root, className)} onSubmit={handleSubmit}>


          <div className={classes.fields}>
            <FormControl variant="outlined" className={classes.formControl}>
              <TextField
                size="small"
                fullWidth
                select
                label={t('Durum')}
                id="StatusId"
                onChange={handleChangeDurum}
                value={sonDurum || '4'}
                variant="outlined"
              >
                {StatusData.map(p => {
                  return (
                    <MenuItem
                      onClick={handleStatusChangeText}
                      key={p.StatusId}
                      value={p.StatusId}
                    >
                      {p.FieldText}
                    </MenuItem>
                  );
                })}
              </TextField>
            </FormControl>
          </div>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={6}>
              <div className={classes.fields}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('islem_Yeri')}
                    onChange={handleChangeIslemYeri}
                    value={islemYeri || '1'}
                    variant="outlined"
                  >
                    {PlaceData.map(p => {
                      return (
                        <MenuItem key={p.Id} value={p.Id}>
                          {p.Dsc}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </FormControl>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <div className={classes.fields}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('lblSourceOfDefect')}
                    onChange={handleChangeSourceOfDefect}
                    value={sourceOfDefect}
                    variant="outlined"
                  >
                    {sourceOfDefectData.map(p => {
                      return (
                        <MenuItem key={p.Id} value={p.Id}>
                          {p.Dsc}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </FormControl>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} lg={6}>
              <div className={classes.fields}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('Tahsilat_Tipi')}
                    onChange={handleChangeTahsilatTipi}
                    value={tahsilatTipi}
                    variant="outlined"
                  >
                    {activePaymentTypeData &&
                      activePaymentTypeData.map(p => {
                        return (
                          <MenuItem key={p.Id} value={p.Id}>
                            {p.Dsc}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                </FormControl>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <div className={classes.fields}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('lblReworkStatus')}
                    id="ReworkId"
                    onChange={handleChangeRework}
                    value={reworkDurum}
                    variant="outlined"
                    SelectProps={{
                      MenuProps: {
                        style: { maxHeight: 350 },
                      },
                    }}
                  >
                    {ReworkData &&
                      ReworkData.map(p => {
                        return (
                          <MenuItem key={p.Id} value={p.Id}>
                            {p.Dsc}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                </FormControl>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} lg={6}>
              <div className={classes.fields}>
                <TextField
                  label={t('Proje_Kodu')}
                  name="ProjeKodu"
                  multiline
                  size="small"
                  fullWidth
                  value={sessionStorage.getItem('ProjectCode') || ProjeKodu}
                  onChange={handleChangeProjeKodu}
                  variant="outlined"
                  disabled={readonly}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={6} lg={6}>
              <div className={classes.fields}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    disabled={WarrantyTypeId[0]?.WarrantyGroupId !== 13}
                    label={t('lblRefurbishmentGrade')}
                    id="RefurbishmentId"
                    onChange={handleChangeRefurbishment}
                    value={RefurbishmentId}
                    variant="outlined"
                  >
                    {RefurbishmentData &&
                      RefurbishmentData.map(p => {
                        return (
                          <MenuItem key={p.Id} value={p.Id}>
                            {p.Grade}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                </FormControl>
              </div>
            </Grid>
          </Grid>




          {SessionUser.TenantId == 75 && (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} lg={6}>
                <div className={classes.fields}>
                  <TextField
                    label={t('Old Compressor Number')}
                    name="CustomerErrorCode"
                    multiline
                    size="small"
                    fullWidth
                    value={SonlandirData[0]?.CustomerErrorCode || ''}
                    onChange={handleChangeCompressorNumber}
                    variant="outlined"
                    disabled={readonly}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6} lg={6}>
                <div className={classes.fields}>
                  <TextField
                    label={t('New Compressor Number')}
                    name="ServiceErrorCode"
                    multiline
                    size="small"
                    fullWidth
                    value={SonlandirData[0]?.ServiceErrorCode || ''}
                    onChange={handleChangeCompressorNumber}
                    variant="outlined"
                    disabled={readonly}
                  />
                </div>
              </Grid>
            </Grid>
          )}

          <div className={classes.fields}>
            <TextField
              label={t('lblStatusNote')}
              name="SonucNotu"
              multiline
              error={IsStatusNoteRequired && SonucNotu.length < 5 ? Required : false}
              rows={4}
              fullWidth
              value={SonucNotu}
              onChange={handleChangeSonucNotu}
              variant="outlined"
              disabled={readonly}
              inputProps={{ maxLength: 2000 }}
            />
          </div>
          <div className={classes.fields}>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              {t('Garanti_tip')}{' '}
              <b style={{ color: colors.red[300] }}>
                {SonlandirData[0]?.WarrantyTypeText}
              </b>
            </Typography>
            {WarrantyTypeId[0]?.WarrantyGroupId === 2 ?
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                {('Payment Status')}{' '}
                <b style={{ color: colors.red[300] }}>
                  Awaiting
                </b>
              </Typography>
              : ''}
          </div>
          {
            SessionUser.ServiceShopPriceVisible ?
              <>
                <div className={classes.fields}>
                  <Typography
                    className={classes.title}
                    align="right"
                    color="textSecondary"
                    gutterBottom
                  >
                    {t('iscilik_Toplami')}{' '}
                    <b>
                      {`${moneyFormat(
                        currLabourSum,
                        SessionUser.TenantCode,
                        SessionUser.CurrencyUnit
                      )} ${SessionUser.CurrencyUnit}`}{' '}
                    </b>
                  </Typography>
                </div>
                <div className={classes.fields}>
                  <Typography
                    className={classes.title}
                    align="right"
                    color="textSecondary"
                    gutterBottom
                  >
                    {t('malzeme_Toplami')}{' '}
                    <b>
                      {`${moneyFormat(
                        currMaterialSum,
                        SessionUser.TenantCode,
                        SessionUser.CurrencyUnit
                      )} ${SessionUser.CurrencyUnit}`}{' '}
                    </b>
                  </Typography>
                </div>
                <div className={classes.fields}>
                  <Typography
                    className={classes.title}
                    align="right"
                    color="textSecondary"
                    gutterBottom
                  >
                    {t('yan_odeme_Toplami')}{' '}
                    <b>
                      {moneyFormat(
                        transportTotal,
                        SessionUser.TenantCode,
                        SessionUser.CurrencyUnit
                      )}
                      {` ${SessionUser.CurrencyUnit}`}{' '}
                    </b>
                  </Typography>
                </div>
                <div className={classes.fields}>
                  <Typography
                    className={classes.title}
                    align="right"
                    color="textSecondary"
                    gutterBottom
                  >
                    {t('lblExtraTotal')}{' '}
                    <b>
                      {moneyFormat(
                        extraTotal,
                        SessionUser.TenantCode,
                        SessionUser.CurrencyUnit
                      )}
                      {` ${SessionUser.CurrencyUnit}`}{' '}
                    </b>
                  </Typography>
                </div>
                <div className={classes.fields}>
                  <Typography
                    className={classes.title}
                    align="right"
                    color="textSecondary"
                    gutterBottom
                    style={{ color: 'red' }}
                  >
                    {t('lblVatTotal')}{' '}
                    <b>
                      {`${moneyFormat(
                        (currLabourSum +
                          currMaterialSum +
                          transportTotal +
                          extraTotal)

                        ,
                        SessionUser.TenantCode,
                        SessionUser.CurrencyUnit
                      )} ${SessionUser.CurrencyUnit}`}{' '}
                    </b>
                  </Typography>
                </div>
                <div className={classes.fields}>
                  <Typography
                    className={classes.title}
                    align="right"
                    color="textSecondary"
                    gutterBottom
                    style={{ color: 'red' }}
                  >
                    {SessionUser.TenantId == 71 || SessionUser.TenantId == 72 || SessionUser.TenantId == 48 ? t('lblGst') : t('lblVat')}{' '}
                    <b>
                      {(() => {
                        const vatInclusiveTotal = Math.round((
                          currMaterialVatSum +
                          currLabourVatSum +
                          transportTotalWithWat +
                          extraTotalWithWat
                        ) * 100) / 100;
                        const vatAmount = isPosTenant
                          ? Math.round((vatInclusiveTotal - Math.round((vatInclusiveTotal / (1 + posVatRate)) * 100) / 100) * 100) / 100
                          : (vatInclusiveTotal - (
                            currMaterialSum +
                            currLabourSum +
                            transportTotal +
                            extraTotal
                          ));
                        return `${moneyFormat(vatAmount, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`;
                      })()}{' '}
                    </b>
                  </Typography>
                </div>
                <div className={classes.fields}>
                  <Typography
                    className={classes.title}
                    align="right"
                    color="textSecondary"
                    gutterBottom
                    style={{ color: 'red' }}
                  >
                    {t('Toplam')}{' '}
                    <b>
                      {`${moneyFormat(
                        (currLabourVatSum +
                          currMaterialVatSum +
                          extraTotalWithWat +
                          transportTotalWithWat)
                        ,
                        SessionUser.TenantCode,
                        SessionUser.CurrencyUnit
                      )} ${SessionUser.CurrencyUnit}`}{' '}
                    </b>
                  </Typography>
                </div>
                <br />
              </> :
              null
          }

          {parseInt(SessionUser.TenantId) === 75 ? (
            <Grid container spacing={2}>
              <Grid item xs={canShowDiscount ? 6 : 12}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={openPaymentDetailsDialog}
                >
                  {t('lblPaymentDetails', 'Payment Details')}
                </Button>
              </Grid>
              {canShowDiscount && (
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    onClick={openManualDiscountDialog}
                  >
                    {t('Discount')}
                  </Button>
                </Grid>
              )}
            </Grid>
          ) : canShowDiscount ? (
                <>
                  <br />
                  <div className={classes.fields}>
                    <div className={classes.fields}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <TextField
                          size="small"
                          fullWidth
                          select
                          label={t('lblDiscountType')}
                          id="DiscountTypeId"
                          onChange={handleChangeDiscountType}
                          value={SonlandirData[0]?.DiscountTypeId || ''}
                          variant="outlined"
                        >
                          {DiscountTypeData.map(p => (
                            <MenuItem key={p.Id} value={p.Id}>{p.Dsc}</MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    </div>
                    <div className={classes.fields}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <TextField
                          size="small"
                          fullWidth
                          select
                          label={t('lblDiscountRate')}
                          id="DiscountRateId"
                          onChange={handleChangeDiscountRate}
                          value={SonlandirData[0]?.DiscountRateId || ''}
                          variant="outlined"
                        >
                          {DiscountRateData.filter(r => r.DiscountTypeId === DiscountTypeId).map(p => (
                            <MenuItem key={p.Id} value={p.Id}>%{p.Rate}</MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    </div>
                  </div>
                </>
              ) : null
          }

          <div className={classes.fields}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} lg={12} style={{ textAlign: 'right' }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isButtonDisabled}
                  onClick={event => handleMerkezeGonder(event, 0)}
                  endIcon={<LockIcon />}
                >
                  {t('lblUpdate')}
                </Button>

                {PayButtonActive && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenPaymentDialog}
                    className={classes.submitButton}
                    startIcon={<CreditCardIcon />}
                  >
                    {t('Payment')}
                  </Button>
                )}

              </Grid>
            </Grid>
          </div>


        </form>
      </CardContent>
      <Dialog
        open={OpenResponse}
        onClose={() => setOpenResponse(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <List dense={false}>
              {ResponseData.map((item, index) => (
                <ListItem key={index}>
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenResponse(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseCancellationPopup}
        aria-labelledby="customized-dialog-title"
        open={openCancellationPopup}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleCloseCancellationPopup}
        ></DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                size="small"
                fullWidth
                autoSelect
                disableClearable
                value={CancellationReasonId || ''}
                options={cancellationReasonsData || []}
                getOptionLabel={option => (option.MainLanguageDescription ? option.MainLanguageDescription : '')}
                getOptionSelected={(option, value) => option.Id === value.Id}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('lblCancellationReason')}
                    variant="outlined"
                  />
                )}
                onChange={(event, value) => {
                  setCancellationReasonId(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                size="small"
                id="desc"
                autoComplete="no"
                multiline
                rows={10}
                value={CancellationNote}
                onChange={event => setCancellationNote(event.target.value)}
                fullWidth
                label={t('lblCancellationNote')}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => SaveCancellation(8)}
            aria-label="save"
            disabled={CancellationNote.length === 0 || CancellationReasonId.Id === 0}
            component="span"
            endIcon={<SaveIcon />}
          >
            {t('lblSave')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari1}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ClosePopupControl}
        onClose={() => {
          setClosePopupControl(false);
          clearUnusedItemsCheckBox()
        }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          <Typography variant="h5" component="h2">
            {ClosePopupHeader}
          </Typography>
        </DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={event => {
              handleMerkezeGonderEvet(event, CloseTypePopupControl1);
              clearUnusedItemsCheckBox()
            }
            }
            color="primary"
            disabled={isButtonDisabled2}
          >
            {CloseBtn1}
          </Button>
          <Button
            variant="contained"
            onClick={event => {
              handleMerkezeGonderEvet(event, CloseTypePopupControl2)
              clearUnusedItemsCheckBox()
            }

            }
            color="primary"
            disabled={isButtonDisabled2}
          >
            {CloseBtn2}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <ForPartner MaterialOrderIdPopup={MaterialOrderId} onCancel={() => { isCancelledRef.current = true; }} onSapSent={() => { isCancelledRef.current = true; }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenTriageMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={() => handleCloseTriageMaterialOrder()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <TriageMaterialOrder
            MaterialIds={matchedPairs.map(p => p.material?.MaterialId)}
            WorkOrderId={ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo}
            ServiceShopId={SonlandirData[0]?.ServiceShopId}
            getOrderNr={getOrderNr}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseTriageMaterialOrder()} color="primary">
            <CloseIcon />
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenUsedNotUsedDialog}
        fullWidth={true}
        maxWidth={'md'}
        onClose={() => { setOpenUsedNotUsedDialog(false); clearUnusedItemsCheckBox() }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          {error && <Grid item xs={6} md={12} style={{ backgroundColor: "#1d3343", padding: "6px 14px" }}>
            <Typography variant="h6" gutterBottom style={{ color: "white" }}>
              You have to select all items!
            </Typography>
          </Grid>}

          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Defect Name</TableCell>
                  <TableCell align="left">Material </TableCell>
                  <TableCell align="left">Used</TableCell>
                  <TableCell align="left">Not Used</TableCell>
                </TableRow>
              </TableHead>
              {cloneArray?.map((row, index) => {
                return (<TableRow key={index}>
                  <TableCell align="left">
                    <Typography>
                      {row.DefectDesc}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography>
                      {row.MaterialCode} - {row.MaterialDesc}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <FormControlLabel control={<Checkbox checked={row.is_selected} onChange={(e) => { checkSelection({ index, value: true, id: row.MaterialId }) }} />} />
                  </TableCell>
                  <TableCell align="left">
                    <FormControlLabel control={<Checkbox checked={row.is_selected !== null && !row.is_selected} onChange={(e) => { checkSelection({ index, value: false, id: row.MaterialId }) }} />} /></TableCell>
                </TableRow>)
              })}
            </Table>
          </TableContainer>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenUsedNotUsedDialog(false); clearUnusedItemsCheckBox() }} color="primary">
            Cancel {/* {t('Tamam')} */}
          </Button>
          <Button onClick={() => handleSelectedUnusedItems()} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenAIDialog}
        onClose={() => setOpenAIDialog(false)}
        fullWidth
        maxWidth="xl"
        style={{ width: '100%', height: '100%' }}
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblAIPredictions')}
        </DialogTitle>
        <DialogContent>
          <React.Fragment>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <Typography variant="h6">{t('lblDefects')}</Typography>
                {defectsAndMaterials.map((defect, index) => (
                  defect.DefectCode && defect.Defect && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${defect.CategoryLevel2 + ', ' + defect.DefectType + ' - ' + defect.Defect}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedDefect === defect}
                            onChange={() => handleDefectSelect(defect)}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
              <Grid item xs={2}>
                {/* Match button */}
                <Grid container spacing={2} direction="column" alignItems="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleMatch}
                    disabled={!selectedDefect || !selectedMaterial}
                  >
                    {t('lblMatch')}
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={5} style={{ flexBasis: '40%' }}>
                <Typography variant="h6">{t('lblMaterials')}</Typography>
                {defectsAndMaterials.map((material, index) => (
                  material.MaterialCode && material.MaterialDsc && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${material.MaterialCode}-${material.MaterialDsc}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedMaterial === material && selectedDefect}
                            onChange={() => handleMaterialSelect(material)}
                            disabled={matchedPairs.some(pair => pair.material?.MaterialCode === material.MaterialCode) || !selectedDefect}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Card>
                <Hizmet matchedPairsArray={matchedPairs ? matchedPairs : []} handleAddMatchedPairs={handleAddMatchedPairs} ReceiptNo={ReceiptNo} readonly={false} />
              </Card>
            </Grid>
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblAlreadyUsed')}</Typography>
            {defectAndMaterialList.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair ? `${pair.Defect} | ${pair.Material}` : ''}</Typography>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblMatches')}</Typography>
            {matchedPairs.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair.material ? `${pair.defect.DefectCode}-${pair.defect.Defect} | ${pair.material?.MaterialCode}-${pair.material?.MaterialDsc}` : `${pair.defect.DefectCode}-${pair.defect.Defect}`}</Typography>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: 'right' }}>
                    <IconButton onClick={() => handleDeleteMatchedPair(index)}>
                      <DeleteIcon style={{ color: '#9B4444' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Grid container spacing={2} justify="center">
              <Grid item>
                <Tooltip title={t('lblWithoutOrderTip')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<RemoveShoppingCartIcon />}
                    endIcon={<span style={{ width: 20 }} />}
                    style={{ backgroundColor: '#8CB9BD' }}
                    onClick={() => TriagePreorderOperations(false)}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblWithoutOrder')}</span>
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title={t('lblSaveAndOrder')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    endIcon={<ShoppingCartIcon />}
                    style={{ backgroundColor: '#344955' }}
                    disabled={!hasMaterialAndDefect}
                    onClick={() => {
                      TriagePreorderOperations(true)
                      setOpenTriageMaterialOrder(true)
                    }}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblSaveAndOrderHeader')}</span>
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </React.Fragment>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            endIcon={<CloseIcon />}
            style={{ backgroundColor: '#344955' }}
            onClick={() => setOpenAIDialog(false)}
          >
            <span style={{ margin: '0 auto' }}>{t('lblCancel')}</span>
          </Button>
        </DialogActions>
        <Backdrop open={LoadingControl} style={{ zIndex: 1000 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      <ManualDiscountDialog
        open={showManualDiscountDialog}
        workOrderId={ReceiptNo}
        loading={manualDiscountLoading}
        items={manualDiscountItems}
        dawlanceShares={dawlanceShares}
        serviceShopTypeId={currentServiceShopTypeId}
        discountRatio={discountRatio}
        setLabourTotal={setDiscountLabourTotal}
        setMaterialTotal={setDiscountMaterialTotal}
        setTransportTotal={setDiscountTransportTotal}
        setExtraTotal={setDiscountExtraTotal}
        onDetailsChange={setDiscountDetails}
        successMessage={discountSuccessMessage}
        errorMessage={discountErrorMessage}
        onSuccessClose={() => {
          setDiscountSuccessMessage('');
          setShowManualDiscountDialog(false);
          getTasksRequest(parseInt(ReceiptNo));
        }}
        onApply={applyManualDiscount}
        onClose={() => setShowManualDiscountDialog(false)}
      />
      <PaymentDetailsDialog
        open={showPaymentDetailsDialog}
        onClose={() => setShowPaymentDetailsDialog(false)}
        workOrderId={ReceiptNo}
        data={paymentDetailsData}
        openDate={SonlandirData[0]?.CreateDate || SonlandirData[0]?.WorkCaseCallDate || SonlandirData[0]?.AppointmentDate}
      />

      <Dialog
        open={showPaymentDialog}
        onClose={handleClosePaymentDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{t('Payment')}</DialogTitle>
        <DialogContent>
          {/* POS Machine Selector */}
          <div style={{ marginBottom: 16 }}>
            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
              POS
            </Typography>
            {posMatchingLoading ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress size={20} />
                <Typography variant="body2" style={{ marginLeft: 8 }}>Loading POS machines...</Typography>
              </div>
            ) : posMatchingList.length > 0 ? (
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>POS</InputLabel>
                <Select
                  value={selectedPos}
                  onChange={(e) => setSelectedPos(e.target.value)}
                  label="POS"
                >
                  {(posMatchingList || []).filter(p => p?.Active).map((pos) => (
                    <MenuItem key={pos?.Id} value={pos?.PosMachineIdentifier || ''}>
                      {pos?.PosMachineTypeName || ''} — {pos?.PosMachineIdentifier || ''}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No POS machines found for this employee.
              </Typography>
            )}
          </div>

          {/* RepairPreSale trigger button */}
          <div style={{ marginBottom: 16 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CreditCardIcon />}
              onClick={handleRepairPreSale}
              disabled={repairLoading || totalWithVat <= 0 || !selectedPos}
            >
              {repairLoading
                ? <CircularProgress size={20} color="inherit" />
                : `${t('Payment')} - ${moneyFormat(totalWithVat, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${paymentCur}`}
            </Button>
          </div>

          {/* Loading state */}
          {repairLoading && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 24, minHeight: 120 }}>
              <CircularProgress size={48} />
              <Typography variant="body2" style={{ marginLeft: 12 }}>Processing...</Typography>
            </div>
          )}

          {/* Error display */}
          {(paymentLocalError || repairError) && (
            <div style={{ marginTop: 16 }}>
              <Typography variant="body2" color="error" style={{ fontWeight: 600 }}>
                {paymentLocalError || (typeof repairError === 'string' ? repairError : JSON.stringify(repairError))}
              </Typography>
            </div>
          )}

          {/* Payment reference info */}
          {repairData && !showPaymentIframe && (
            <div style={{ marginTop: 16 }}>
              <Typography variant="body2" color="textSecondary">
                Payment Reference: <strong>{repairData.PaymentReference || '-'}</strong>
              </Typography>
              {repairData.HasApplicationSingleProvider && (
                <Typography variant="body2" color="primary" style={{ marginTop: 4 }}>
                  Payment link has been delivered to the customer.
                </Typography>
              )}
            </div>
          )}

          {/* Payment iframe */}
          {showPaymentIframe && paymentIframeUrl && (
            <div style={{ marginTop: 24 }}>
              <Typography variant="h6" gutterBottom align="center">
                Complete Your Payment
              </Typography>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minHeight: '400px'
                }}
              >
                <iframe
                  src={paymentIframeUrl}
                  style={{
                    width: '100%',
                    height: '500px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 4px 16px -6px rgba(0,0,0,.18)'
                  }}
                  title="Payment"
                />
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePaymentDialog} color="primary">
            {t('iptal')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}
Sonlandir.propTypes = {
  className: PropTypes.string
};
export default connect(state => ({
  tasks: state.tasks1,
  materialReducer: state.materialReducer
}), { setTask, getTasksRequest })(
  Sonlandir
);
